








import {Vue, Component, Prop} from 'vue-property-decorator';
@Component({
    components: {
    },
})
export default class NavigationDrawerListItem extends Vue {
    @Prop({default: ''})
    public icon!: string;
    @Prop({default: ''})
    public text!: string;
    @Prop({default: undefined})
    public to!: string;
    @Prop({default: false})
    public exact!: boolean;
}
